package com.rainbowclubs.rainbow.domain.use_cases.club

import com.rainbowclubs.rainbow.data.models.Club
import com.rainbowclubs.rainbow.domain.repositories.ClubRepository

class GetClubUseCase(
    private val clubRepository: ClubRepository,
) {
    suspend operator fun invoke(clubId: String): Result<Club> {
        return try {
            clubRepository.getClubById(clubId).onSuccess {
                return Result.success(it)
            }.onFailure {
                return Result.failure(it)
            }
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun image(imageUrl: String): Result<ByteArray> {
        return clubRepository.getClubImage(imageUrl)
    }
}
